<h2 mat-dialog-title>Add milestone event</h2>

<div mat-dialog-content>
  @if (data.studentName) {
    <div class="tw:text-[13px] tw:font-semibold tw:text-[#333] tw:mb-3">{{ data.studentName }}</div>
  }

  <label class="field__label">Event date</label>
  <input type="date" class="field__control tw:w-full tw:mb-3" [(ngModel)]="eventDate" />

  <label class="field__label">Event description</label>
  <textarea class="field__control tw:w-full" [(ngModel)]="eventDescription" rows="5" [maxlength]="maxLength"
    placeholder="Describe the event and how it may affect the learner…"></textarea>
  <div class="tw:text-[12px] tw:text-right tw:text-[#777]">{{ eventDescription.length }}/{{ maxLength }}</div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()" [disabled]="saving">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!canSave">Save</button>
</div>
